<template lang="pug" src="./template/TrendingTopLatest.pug"></template>
<style lang="stylus" src="./styles/TrendingTopLatest.styl" scoped></style>

<script>
export default {
    data() {
        return {
            selectedTtl: 0,
            ttl: [
                'Hot',
                'Top',
                'Latest',
            ],
        };
    },

    created() {
        if (this.$route.query.type) {
            this.selectedTtl = this.ttl.indexOf(this.$route.query.type);
        }
    },

    methods: {
        setTtlIndex(index) {
            this.selectedTtl = index;
            const order = this.ttl[index];
            const params = this.$route.query;

            this.$router.push({ path: '', query: { ...params, type: order, key:Math.round(Math.random() * (100-1) + 1) } });
        },

    },

};
</script>
